var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDurability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0393 11.7597C20.878 11.9211 20.6282 11.9614 20.4223 11.8595L17.7185 10.5207C17.6152 10.4695 17.532 10.3866 17.4815 10.2847L16.1326 7.55907C16.0356 7.36301 16.0747 7.12855 16.2305 6.97281L19.55 3.65355C19.8327 3.3708 19.6964 2.90109 19.2951 2.8518C17.2685 2.60292 15.1407 3.2648 13.5723 4.83313C11.7727 6.63259 11.1662 9.16867 11.7595 11.4435L3.81627 19.3862C2.4737 20.7287 2.45924 22.8911 3.78398 24.2162C5.10872 25.5412 7.271 25.5271 8.61357 24.1846L16.5568 16.2419C18.8313 16.8356 21.3673 16.2294 23.1669 14.43C24.7311 12.8659 25.3939 10.7454 25.1509 8.72354C25.1028 8.32306 24.6102 8.1891 24.3218 8.47746L21.0393 11.7597Z",
    stroke: "black",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurability);
export default __webpack_public_path__ + "static/media/durability.a927855c.svg";
export { ForwardRef as ReactComponent };